/*
 * qty-break-price-sync.js — Lyvoi PDP
 * Mirrors the selected quantity-break (Single/Duo/Triple) bundle total + compare
 * into the MAIN product price block, so users get visual feedback on selection.
 * DISPLAY-ONLY. Never touches the add-to-cart form / submit / cart logic.
 * Fully wrapped in try/catch: any failure is silent and cannot break ATC.
 * Added 2026-06-22 to fix Clarity dead-clicks on the bundle selector.
 */
(function () {
  'use strict';
  function sync() {
    try {
      var pc = document.querySelector('.price__container');
      if (!pc) return;
      var r = document.querySelector('input[name="quantity"]:checked');
      if (!r) return;
      var label = document.querySelector('label[for="' + r.id + '"]');
      if (!label) return;
      var cardSale = label.querySelector('.quantity-break__price');
      if (!cardSale) return;
      var sale = cardSale.textContent.trim();
      if (!/\$\s*[\d,]/.test(sale)) return; // safety: only act on a real price
      pc.querySelectorAll('.main-price').forEach(function (el) {
        el.textContent = ' ' + sale + ' ';
      });
      var cardCmp = label.querySelector('.quantity-break__compare-price');
      var cmpEl = pc.querySelector('.price__compare-price');
      if (cmpEl && cardCmp) {
        var cmp = cardCmp.textContent.trim();
        if (/\$\s*[\d,]/.test(cmp)) cmpEl.textContent = ' ' + cmp + ' ';
      }
      // 2026-10-04: sticky ATC showed the page-load variant ($220 20″) while the
      // bundle had Mini/Duo selected. Mirror bundle total + item #1 into it.
      // .sale (1.7.0) wraps the amount in a span; .com's older markup is bare "$220.00 • ".
      document.querySelectorAll('.sticky-atc [id^="sticky-atc-price-"]').forEach(function (el) {
        var span = el.querySelector('[class^="main-atc-price-span-"]');
        if (span) span.textContent = sale;
        else el.textContent = ' ' + sale + ' • ';
      });
      var stickySel = document.querySelector('.sticky-atc__variant-select');
      var c = label.querySelector('select[name="options[Color]"]');
      var s = label.querySelector('select[name="options[Size]"]');
      if (stickySel && c && s) {
        var v = c.value + ',' + s.value;
        if ([].some.call(stickySel.options, function (o) { return o.value === v; })) stickySel.value = v;
      }
    } catch (e) { /* silent — never break the page */ }
  }
  function boot() { setTimeout(sync, 800); }
  try {
    // re-sync on bundle change (capture phase, passive) and on variant change
    document.addEventListener('change', function (e) {
      if (e && e.target && e.target.name === 'quantity') setTimeout(sync, 60);
      else if (e && e.target && /options\[/.test(e.target.name || '')) setTimeout(sync, 250);
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  } catch (e) { /* silent */ }
})();
